import React from 'react';
import { Badge, Box, FormField, SegmentedControl, SpaceBetween, Toggle } from '@amzn/awsui-components-react';
import { LEF_DRILLDOWN_DIMENSIONS } from 'src/utils/constants';
import { getDrillDownDimension, isAccountDimension } from 'src/components/reports/segmentDrillDown';

/**
 * Control bar above the TP P&L grid: the drill-down dimension selector plus the zero-value-segment
 * toggle. Rendered only when lefSegmentDrillDownEnabled is on; state lives in the report view so it
 * survives Functional Segment and page changes.
 */
export default function DrillDownDimensionSelector(props: {
    selectedDimensionId: string;
    onDimensionChange: (dimensionId: string) => void;
    showZeroValueSegments: boolean;
    onShowZeroValueSegmentsChange: (showZeroValueSegments: boolean) => void;
    disabled?: boolean;
}) {
    const dimension = getDrillDownDimension(props.selectedDimensionId);

    return (
        <Box padding={{ horizontal: 'l', top: 's', bottom: 's' }}>
            <SpaceBetween direction="horizontal" size="xl" alignItems="end">
                <FormField
                    label={
                        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                            <span>Drill-down dimension</span>
                            <Badge color="blue">NEW</Badge>
                        </SpaceBetween>
                    }>
                    <SegmentedControl
                        selectedId={dimension.id}
                        onChange={({ detail }) => props.onDimensionChange(detail.selectedId)}
                        options={LEF_DRILLDOWN_DIMENSIONS.map((option) => ({
                            id: option.id,
                            text: option.label,
                            disabled: props.disabled,
                        }))}
                        label="Drill-down dimension"
                    />
                </FormField>
                {/* Account is the unsplit view and has no segment rows, so the toggle has nothing to
                    act on there. Hiding it rather than disabling it keeps the Account view identical
                    to the flag-off layout. */}
                {!isAccountDimension(dimension) && (
                    <Toggle
                        checked={props.showZeroValueSegments}
                        disabled={props.disabled}
                        onChange={({ detail }) => props.onShowZeroValueSegmentsChange(detail.checked)}>
                        Show zero-value segments
                    </Toggle>
                )}
            </SpaceBetween>
        </Box>
    );
}
